<div class="toggleContainer" [class.readonly]="readonly">
  <input
    class="toggleInput"
    type="checkbox"
    [formControl]="control"
    [id]="id ?? labelId"
    (change)="onChange($event)"
    #inputRef
  />
  <label class="toggleLabel" (click)="toggleValue(inputRef)">
    <span class="toggleSlider"></span>
  </label>
</div>
<div class="text-label" *ngIf="label?.trim().length">
  <span (click)="toggleValue(inputRef)">{{label}}</span>
  <app-dc-popover
      *ngIf="helpText?.trim().length"
      [body]="helpText"
      [class.helpText]="helpText"
      [autoClose]="2000"
    ></app-dc-popover>
</div>
